import { createContext, useContext } from 'react';

import type { EventConfig, Tracker } from './ExperienceTracker';

const ExperienceTrackerContext = createContext<Tracker<string> | null>(null);

interface ExperienceTrackerProviderProps {
  tracker: Tracker<EventConfig>;
  children: React.ReactNode;
}

export function ExperienceTrackerProvider({ tracker, children }: ExperienceTrackerProviderProps) {
  return <ExperienceTrackerContext.Provider value={tracker}>{children}</ExperienceTrackerContext.Provider>;
}

export function useExperienceTracker<TEventDef extends EventConfig = string>(): Tracker<TEventDef> {
  const tracker = useContext(ExperienceTrackerContext);

  if (!tracker) {
    throw new Error('useExperienceTracker must be used within an ExperienceTrackerProvider');
  }

  return tracker as Tracker<TEventDef>;
}
